export const getEnumValuesArray = <T extends object>(e: T): string[] =>
  Object.values(e).filter((v) => typeof v === "string") as string[];

const getEnumNames = <T extends object>(e: T): (keyof T)[] =>
  Object.keys(e).filter((key) => isNaN(Number(key))) as (keyof T)[];

const getEnumValues = <T extends object>(e: T): number[] =>
  Object.values(e).filter((value) => !isNaN(Number(value))) as number[];

export const getEnumSelectOptions = <T extends object>(e: T) =>
  getEnumNames(e).map((name, index) => ({
    name,
    value: getEnumValues(e)[index],
  }));